<template>
  <cool-select :list="getAvailableAddressIncludingCurrentlySelected"
               option-value="addressFullName"
               option-text="displayName"
               :placeholder="$t('CONTENT.choose')"
               v-model="selectModel"
  ></cool-select>
</template>

<script>
	import {mapGetters} from 'vuex';

	export default {
		props:{
			addressTypeFullName: {
				required: true,
      }
    },
		data() {
			return {
				currentlySelectedAddressType: null
			}
		},

    created() {
			this.currentlySelectedAddressType = this.allCounterpartyAddressTypes.find(a=>a.addressFullName === this.addressTypeFullName.addressType);
    },

    watch: {
			currentlySelectedAddressType(newVal, oldVal){
				if (oldVal != null){
					this.$store.commit('REMOVE_SELECTED_ADDRESS_TYPES', oldVal);
        }

				this.$store.commit('ADD_SELECTED_ADDRESS_TYPES', newVal);
      }
    },
    computed: {
			...mapGetters(['allCounterpartyAddressTypes']),
			...mapGetters(['getAvalableAdressTypes']),
    	getAvailableAddressIncludingCurrentlySelected() {
				let available = [];
				for (let i = 0; i < this.getAvalableAdressTypes.length; i++) {
					available.push(this.getAvalableAdressTypes[i])
				}
				if (this.currentlySelectedAddressType != null){
					available.push(this.currentlySelectedAddressType)
        }

    		return available;
      },
			selectModel: {
				get() {
					return this.addressTypeFullName.addressType;
				},
        set(newVal) {
					this.$store.commit('UPDATE_EDITED_ADDED_ADDRESS', {oldAddressType: this.addressTypeFullName.addressType, currentAddressType: newVal});

					this.addressTypeFullName.addressType = newVal;

          this.currentlySelectedAddressType = this.allCounterpartyAddressTypes.find(a=>a.addressFullName === newVal);
				}
			}
    },
	}
</script>
